<ng-container *ngIf="transcriptWordList?.length">
  <ng-container *ngFor="let group of transcriptWordList">
    <ng-container *ngIf="group.hasHeader">
      <h2>
        <app-word
          [currentTime]="currentTime"
          [wordList]="group.wordList"
        ></app-word>
      </h2>
    </ng-container>
    <ng-container *ngIf="group.hasNewline">
      <p>
        <app-word
          [currentTime]="currentTime"
          [wordList]="group.wordList"
        ></app-word>
      </p>
    </ng-container>
    <ng-container *ngIf="!group.hasNewline && !group.hasHeader">
      <app-word
        [currentTime]="currentTime"
        [wordList]="group.wordList"
      ></app-word>
    </ng-container>
  </ng-container>
</ng-container>
